import {
  FormControl,
  FormLabel,
  Input,
  Box,
  Flex,
  Button,
  Center,
  Spinner,
  Text,
  useBoolean,
  InputGroup,
  InputRightElement,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginRequest } from "lib/redux/auth/action";
import { type RootReducer } from "lib/redux/reducers";
import { errorToast } from "utils/hooks";
import MetaDecorator from "components/MetaDecorator";
import { PROTECTED_PATHS } from "routes/pagePath";
const LoginForm = () => {
  const history = useNavigate();
  const dispatch = useDispatch();

  const login = useSelector<RootReducer, any>((state) => state.auth.user);
  useEffect(() => {
    if (login.success) {
      history(PROTECTED_PATHS.DASHBOARD);
    }
  }, [history, login]);

  const [formData, setformData] = useState({
    userNameOrEmail: "",
    password: "",
  });
  const [show, setShow] = useBoolean();
  const { userNameOrEmail, password } = formData;
  const handleChange = (e: any) => {
    setformData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (userNameOrEmail === "") {
      errorToast("Please input an email or username");
      return;
    }
    if (password === "") {
      errorToast("Please input a password");
      return;
    }
    dispatch(loginRequest(formData));
  };
  return (
    <Box>
      <MetaDecorator
        title="Login to Choirscipt | Choirscript.com"
        description="Regain access to all solfa notations"
        imageUrl=""
        imageAlt="Login page"
      />
      {login.processing && (
        <Center
          position="absolute"
          top="1px"
          bottom="0"
          left="0"
          right="0"
          width="100%"
          bg="blackAlpha.700"
          height="100%"
          mx="auto"
          zIndex="9"
        >
          <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="blue.500" size="xl" />
          <Text ml={4} display="block" color="#fff">
            Loading...
          </Text>
        </Center>
      )}
      <form onSubmit={handleSubmit}>
        <FormControl isRequired>
          <FormLabel mb={1}>Email or Username</FormLabel>
          <Input
            type="text"
            placeholder="Enter your email address"
            name="userNameOrEmail"
            value={userNameOrEmail}
            onChange={handleChange}
          />
        </FormControl>
        <FormControl mt={4} isRequired>
          <FormLabel mb={1}>Password</FormLabel>
          <InputGroup size="md">
            <Input
              placeholder="Enter your password"
              name="password"
              value={password}
              onChange={handleChange}
              pr="4.5rem"
              type={show ? "text" : "password"}
            />
            <InputRightElement width="4.5rem">
              <Button
                h="1.75rem"
                size="sm"
                variant="secondaryOutline"
                onClick={() => {
                  setShow.toggle();
                }}
              >
                {show ? "Hide" : "Show"}
              </Button>
            </InputRightElement>
          </InputGroup>
        </FormControl>
        <Flex justifyContent="space-between" mt={4}>
          <Button width="100%" mt={4} type="submit" onClick={handleSubmit}>
            Sign In
          </Button>
        </Flex>
      </form>
    </Box>
  );
};
export default LoginForm;
